import React from 'react';
import GlobalHelper from '../Helpers/GlobalHelper';

const ClienteTitle = (props) => {
    const { empresas, novedadesEmpresas, cliente } = props;
    const descripcion = (cliente.EsPersonaFisica ? cliente.Nombre + " " + cliente.Apellido : cliente.RazonSocial)

    const limitesCliente = GlobalHelper.ObtenerLimitesEmpresaCliente(empresas, (novedadesEmpresas || []), cliente);

    let textoSolicitud = "Solicitud para ";
    if (props.esVistaCliente) {
        textoSolicitud = "";
    }

    return (
        <div className="bottom-separator-xs">
            <div className="row">
                <div className="col-md-12">
                    <h1>
                        {(props.esModificacion == true ? textoSolicitud : "Nueva solicitud para ") + descripcion}
                    </h1>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <ul className="no-bullets no-padding no-margin">
                        <li className="inlineListItem lg-margin">
                            <span className="icon-ti-user-icon-persona-cyan"></span>&nbsp;{cliente.TipoDocumento.Codigo} {cliente.numeroDocumentoFormato}
                        </li>
                        <li className="inlineListItem lg-margin left-separator"></li>
                        <li className="inlineListItem lg-margin">
                            <span className="fa fa-money"></span>&nbsp;Límite por CUIT $ {GlobalHelper.FormatearLimite(limitesCliente.LimitePorCuit)}
                        </li>
                        <li className="inlineListItem lg-margin">
                            <span className="icon-available-limit22"></span>&nbsp;Límite asignado: $ {GlobalHelper.FormatearLimite(limitesCliente.LimiteAsignado)}
                        </li>
                        <li className="inlineListItem lg-margin">
                            <span className="icon-available-limit22"></span>&nbsp;Límite sin asignar: $ {GlobalHelper.FormatearLimite(limitesCliente.LimiteSinAsignar)}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default ClienteTitle;